<template>
  <div
    v-loading="loading"
    class="content-wrap"
  >
    <div
      v-if="content"
      v-html="content"
    />
  </div>
</template>

<script>
import api from '@/components/agreementManage/proxy';
export default {
    name: 'Agreen',
    data () {
        return {
            loading: true,
            content: '',
        };
    },
    mounted () {
        this.__init();
    },
    methods: {
        async __init () {
            this.loading = true;
            let { id } = this.__getQueryString(location.search);
            const res = await api.getAgreementContent({
                id: id,
            });
            this.loading = false;
            if (res.errcode !== 0) {
                return false;
            }
            this.content = res.data.content;
        },
        __getQueryString (search) {
            var paramPart = search.substr(1).split('&');
            return paramPart.reduce(function (res, item) {
                let parts = item.split('=');
                res[parts[0]] = parts[1];
                return res;
            }, {});
        },
    },
};
</script>
<style lang="scss" scoped>
.content-wrap {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling:touch;
  padding: 20px 16px 0;
  box-sizing: border-box;
}
</style>
<style lang="scss">
body,html {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
}
</style>
